module.exports = __webpack_public_path__ + "img/shirt.be5030ca.webp";